export enum MpWindowModeEnum {
  FULLSCREEN = 'fullScreen',
  DEFAULT = 'default',
  NEW_WINDOW = 'newWindow'
}
